import React from "react";
import { Stepper } from "react-form-stepper";
import "components/Account/Onboarding/OnboardingStepper.css";

class OnboardingStepper extends React.Component {
  redirectToOnboarding(redirected) {
    window.location.assign(redirected);
  }

  render() {
    return (
      <div>
        <Stepper
          connectorStyleConfig={{ size: 4, stepSize: "4em", style: "solid" }}
          styleConfig={{
            activeBgColor: "#FFFFFF",
            completedBgColor: "#FF6342",
            inactiveBgColor: "#FF6342",
            circleFontSize: "0px",
          }}
          steps={[
            {
              label: <h5>The Believer</h5>,
              onClick: () => {
                this.redirectToOnboarding("/onboarding-believer");
              },
            },
            {
              label: <h5>The Dream</h5>,
              onClick: () => {
                this.redirectToOnboarding("/onboarding-dream");
              },
            },
            {
              label: <h5>The Superpowers</h5>,
              onClick: () => {
                this.redirectToOnboarding("/onboarding-superpower");
              },
            },
            {
              label: <h5>The Causes</h5>,
              onClick: () => {
                this.redirectToOnboarding("/onboarding-cause");
              },
            },
          ]}
          activeStep={parseInt(this.props.currentOnboardingStep)}
        />
      </div>
    );
  }
}

export default OnboardingStepper;
